import React, { FC } from "react";
import { Button, Notification } from "@telia/teddy";
import { Container } from "../../../../components";
import { connect } from "react-redux";
import { CART_ITEM_TYPE } from "../../../../../../constants";
import { RootState } from "../../../../../../models";
import { getAllItemsOfType, hasHandsetItems, hasPreownedHandsetItems } from "../../../state/selectors/cartSelectors";
import { hasSubscriptions } from "../../../state/selectors/subscriptionsSelectors";

interface StateProps {
    hasMobileRefund: boolean;
    hasHandset: boolean;
    hasSubscription: boolean;
}

const MobilPantNotificationWarning: FC<StateProps> = ({ hasMobileRefund, hasHandset, hasSubscription }) => {
    if (!hasMobileRefund) {
        return null;
    }

    if (hasHandset && hasSubscription) {
        return null;
    }

    let message: string;
    if (hasHandset) {
        message = "For å bruke MobilPant trenger du et abonnement. Legg det til for å fortsette.";
    } else if (hasSubscription) {
        message = "For å bruke MobilPant trenger du en telefon. Legg den til for å fortsette.";
    } else {
        message =
            "For å bruke MobilPant må du kjøpe en mobil og et abonnement hos Telia. Legg det til for å fortsette.";
    }

    return (
        <Container size="small" noMargin noPadding>
            <Notification variant="warning">
                <Notification.Icon name="info" />
                <Notification.Text>{message}</Notification.Text>
                {hasHandset && !hasSubscription && (
                    <Notification.Footer>
                        <Button asChild size="sm" variant="text">
                            <a href="/mobilabonnement">
                                Velg abonnement
                                <Notification.Icon name="arrow-right" />
                            </a>
                        </Button>
                    </Notification.Footer>
                )}
                {!hasHandset && hasSubscription && (
                    <Notification.Footer>
                        <Button asChild size="sm" variant="text">
                            <a href="/mobiltelefoner">
                                Velg telefon
                                <Notification.Icon name="arrow-right" />
                            </a>
                        </Button>
                    </Notification.Footer>
                )}
                {!hasHandset && !hasSubscription && (
                    <Notification.Footer>
                        <Button asChild size="sm" variant="text">
                            <a href="/mobiltelefoner">
                                Velg mobil og abonnement
                                <Notification.Icon name="arrow-right" />
                            </a>
                        </Button>
                    </Notification.Footer>
                )}
            </Notification>
        </Container>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    hasMobileRefund: getAllItemsOfType(state, CART_ITEM_TYPE.MOBILE_REFUND).length > 0,
    hasHandset: hasHandsetItems(state) || hasPreownedHandsetItems(state),
    hasSubscription: hasSubscriptions(state),
});

export default connect(mapStateToProps)(MobilPantNotificationWarning);
